import React from 'react';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { TypographyProps } from '../../theme/styledProps';

interface Props extends Pick<TypographyProps, 'fontSize' | 'fontWeight'> {
  title: string;
  cells: number[];
  parent_name?: string;
  forceOdd?: boolean;
  isDetail?: boolean;
  onClick?: () => void;
  color?: string;
}

export const TableRow = ({
  parent_name = '',
  title,
  cells = [],
  forceOdd = false,
  isDetail = false,
  onClick,
  color = 'neutral.700',
  ...rest // text related styles
}: Props) => {
  /**
   * Need to check these values specified on how it affects design
   * while migrating ProjectedCashFlowReportView.jsx into OPL. Right
   * now, only pdf version is migrated.
   */

  //   const o = Object.assign(
  //     {
  //       parent_name: '',
  //       title: '',
  //       cells: [],
  //       force_odd: false,
  //       is_detail: false,
  //       on_click: undefined,
  //       extra_row_classes: '',
  //     },
  //     opts,
  //   );

  //   const rowClasses: string[] = [];
  //   if (o.force_odd) {
  //     rowClasses.push('odd');
  //   }
  //   if (o.is_detail) {
  //     rowClasses.push('detail');
  //   }
  //   if (o.extra_row_classes) {
  //     rowClasses.push(...o.extra_row_classes.split(' '));
  //   }

  const TableRowContent = () => {
    const data = cells.slice(0, 5);
    return (
      <>
        {data.map((val, i) => (
          <td key={i}>
            <Text
              variant="tabular"
              textAlign="right"
              color={val < 0 ? 'error.500' : color}
              {...rest}
            >
              ${ADV.util.number_format(Math.abs(val))}
            </Text>
          </td>
        ))}
      </>
    );
  };

  return (
    <tr>
      <td>
        <Text color={color} {...rest}>
          {title}
        </Text>
      </td>
      <TableRowContent />
    </tr>
  );
};
